/*
 * @Author: zxf
 * @Date: 2022-07-20 14:23:00
 * @LastEditors: zxf
 * @LastEditTime: 2023-02-28 15:57:14
 * @Description: 维保计划管理服务
 */
import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;
export const wbjhService = {

  // 查询
  query: (params) => { return axios.get(`${iffApi}/xfwb/wbjh/query`, { params: params }); },

  // 查询
  queryList: (params) => { return axios.get(`${iffApi}/xfwb/wbjh/queryList`, { params: params }); },

  // 查询
  queryTj: (params) => { return axios.get(`${iffApi}/xfwb/wbjh/queryTj`, { params: params }); },

  // 删除
  delete: (id) => { return axios.delete(`${iffApi}/xfwb/wbjh/${id}`); },

  // 新增
  save: (fd) => { return axios.post(`${iffApi}/xfwb/wbjh`, fd); },

  // 新增
  saveV2: (fd) => { return axios.post(`${iffApi}/xfwb/wbjh/v2`, fd); },

  // 批量更新
  patchSave: (fd) => { return axios.post(`${iffApi}/xfwb/wbjh/patch`, fd); },

  // 更新
  update: (id, fd) => { return axios.put(`${iffApi}/xfwb/wbjh/${id}`, fd); },

  // 获取详情
  getInfo: (id) => { return axios.get(`${iffApi}/xfwb/wbjh/${id}`); },

  // 导出
  export: (params) => { return axios.get(`${iffApi}/wbjh/export`, { responseType: 'blob', params }); },

  // 获取维保项目维保内容
  getWbxmWbnr: (xmid, zq) => { return axios.get(`${iffApi}/xfwb/wbxm/${xmid}/${zq}`); },

  // 获取维保项目详情
  getWbxmInfo: (id) => { return axios.get(`${iffApi}/xfwb/wbxm/${id}`); },

  // 获取维保结论信息
  getWbjlInfo: (id) => { return axios.get(`${iffApi}/xfwb/wbjh/${id}/wbjl`); },

  // 保存维保结论信息
  saveWbjl: (id, fd) => { return axios.put(`${iffApi}/xfwb/wbjh/${id}/wbjl`, fd); },

  // 获取维保计划报告信息
  getWbjhBgxx: (id) => { return axios.get(`${iffApi}/xfwb/wbjh/${id}/bgxx`); },

  //  *****

  // 获取维保项目最新合同信息
  getKhWbht: (khbm) => { return axios.get(`${iffApi}/wbht/${khbm}/lastest`); },

  // 获取分配信息
  queryFpInfo: (params) => { return axios.get(`${iffApi}/wbsb/{khbm}/tj`, { params: params }); },

  // 统计导出
  exportTj: (params) => { return axios.get(`${iffApi}/xfwb/wbjh/exportTj`, { responseType: 'blob', params }); },

  // 获取维保计划详情
  getWbjhDetail: (id) => { return axios.get(`${iffApi}/wbjh/${id}`); },

  // 获取计划详情项目的维保检测项查看
  getWbjcxtb: (params) => { return axios.get(`${iffApi}/xfwb/wbjh/wbsb`, { params: params }); },

  // 维保系统统计
  getWbxtTj: (id) => { return axios.get(`${iffApi}/xfwb/wbjh/${id}/xttj`); }
};
